// Thin wrapper around Plausible's queued global. The `pa-` script in index.html
// auto-tracks pageviews; this is only for custom events.
//
// We send no props: the basic/Growth plan can't break down custom properties,
// so any distinction we care about lives in the event name instead.
export function trackEvent(name) {
  // No-op when Plausible isn't available (dev, ad-blockers) so call sites stay safe.
  if (typeof window === "undefined" || typeof window.plausible !== "function") {
    return;
  }
  window.plausible(name);
}
